import React from 'react';
import classNames from 'classnames';

import styles from './AppLayout.scss';

interface OwnProps {
  flush?: boolean;
  children: React.ReactNode;
}

export default class AppLayout extends React.PureComponent<OwnProps, never> {
  static Container = Container;
  static Section = Section;

  render() {
    const className = classNames(
      styles.Layout,
      this.props.flush && styles.LayoutFlush
    );

    return <div className={className}>{this.props.children}</div>;
  }
}

function Container({
  subdued,
  slim,
  children,
}: {
  subdued?: boolean;
  slim?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      className={classNames(styles.WrapperContainer, subdued && styles.Subdued)}
    >
      <div
        className={classNames(styles.Container, slim && styles.ContainerSlim)}
      >
        {children}
      </div>
    </div>
  );
}

function Section({
  children,
  size,
  fill,
}: {
  children?: React.ReactNode;
  fill?: boolean;
  size?: 'TwoThirds' | 'OneThird' | 'OneFifth';
}) {
  return (
    <section
      className={classNames(
        styles.Section,
        size && styles[size],
        fill && styles.Fill
      )}
    >
      {children}
    </section>
  );
}
